import React from 'react';
import {connect} from 'react-redux';

function Enumeration(props){
  console.log(props.enumerations, 'ENUMERATIONS');
  let x;
  if(props.enumerations!=undefined && props.enumerations[props.enum]!=undefined){
    for(let y of props.enumerations[props.enum]){
      if(y.value==props.value){x=y; break;}
    }
  }
  if(x==undefined){return null;}
  if(props.return=='description'){
    return(<span>{x.description}</span>)
  }else{
    return(<span>{x.name}</span>)
  }
}


export default connect(ss)(Enumeration);


function ss(state){
  return{
    enumerations:state.account.enumerations
  }
}
